// src/pages/Inscription/InfoModal.jsx
import React from "react";
import { FaTimes } from "react-icons/fa";

const InfoModal = ({ isOpen, onClose, acteur }) => {
  if (!isOpen || !acteur) return null;

  const {
    nom,
    prenom,
    email,
    tel,
    adresse,
    cp,
    commune,
    genre,
    date_naissance,
    club_acteur,
    licence_number,
    groupe_souhaite,
  } = acteur;

  const formattedDate =
    date_naissance &&
    new Date(date_naissance).toLocaleDateString("fr-FR", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm">
      <div className="w-full max-w-lg mx-4 rounded-2xl bg-white dark:bg-slate-900 border border-slate-200/80 dark:border-slate-700/80 shadow-2xl overflow-hidden">
        {/* Header */}
        <div className="flex items-center justify-between px-4 py-3 border-b border-slate-200/80 dark:border-slate-700/80 bg-slate-50/80 dark:bg-slate-900/90">
          <h2 className="text-sm md:text-base font-bold text-slate-900 dark:text-white">
            Fiche acteur · {nom} {prenom}
          </h2>
          <button
            onClick={onClose}
            className="inline-flex items-center justify-center w-8 h-8 rounded-full hover:bg-slate-200/80 dark:hover:bg-slate-700/80 text-slate-600 dark:text-slate-200 transition-colors"
            title="Fermer"
          >
            <FaTimes />
          </button>
        </div>

        {/* Contenu */}
        <div className="px-4 py-4 md:py-5 text-sm text-slate-700 dark:text-slate-200 space-y-3 max-h-[70vh] overflow-y-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            <div>
              <p className="text-[11px] uppercase text-slate-400">Nom Prénom</p>
              <p className="font-medium">
                {nom} {prenom}
              </p>
            </div>
            {genre && (
              <div>
                <p className="text-[11px] uppercase text-slate-400">Genre</p>
                <p className="font-medium">{genre}</p>
              </div>
            )}
            {formattedDate && (
              <div>
                <p className="text-[11px] uppercase text-slate-400">
                  Date de naissance
                </p>
                <p className="font-medium">{formattedDate}</p>
              </div>
            )}
            {club_acteur && (
              <div>
                <p className="text-[11px] uppercase text-slate-400">Club</p>
                <p className="font-medium">{club_acteur}</p>
              </div>
            )}
            {licence_number && (
              <div>
                <p className="text-[11px] uppercase text-slate-400">
                  Numéro de licence
                </p>
                <p className="font-medium">{licence_number}</p>
              </div>
            )}
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            {email && (
              <div>
                <p className="text-[11px] uppercase text-slate-400">Email</p>
                <p className="font-medium break-words">{email}</p>
              </div>
            )}
            {tel && (
              <div>
                <p className="text-[11px] uppercase text-slate-400">Téléphone</p>
                <p className="font-medium">{tel}</p>
              </div>
            )}
          </div>

          {adresse && (
            <div>
              <p className="text-[11px] uppercase text-slate-400">Adresse</p>
              <p className="font-medium">
                {adresse}
                {cp || commune ? (
                  <>
                    <br />
                    {cp} {commune}
                  </>
                ) : null}
              </p>
            </div>
          )}

          {groupe_souhaite && (
            <div>
              <p className="text-[11px] uppercase text-slate-400">
                Groupes souhaités
              </p>
              <p className="font-medium whitespace-pre-wrap">
                {groupe_souhaite}
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default InfoModal;
